{
  "#INVENTUR": {
    "APP": "LP-Inventur",
    "APP_DESC": "Verwaltung von Lagerartikel",
    "TITLE": "Inventur",
    "PAGES": {
      "LAGERPLATZ_SCANNEN": {
        "TITLE": "Lagerplatz scannen",
        "DESCRIPTION": "Bitte scannen Sie einen Lagerplatz-Barcode"
      },
      "ARTIKEL_AUSWAHL": {
        "TITLE": "Artikel auswählen",
        "DESCRIPTION": "Bitte Artikel auswählen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "ARTIKEL_INV": "Bereits inventierte Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SUBMIT": "Weiter"
      },
      "MENGEN_AUSWAHL": {
        "TITLE": "Menge auswählen",
        "DESCRIPTION": "Bitte Menge auswählen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SUBMIT": "Weiter"
      }
    },
    "MESSAGES": {
      "SUCCESS": {
        "KORREKTUR": "Der Artikel wurde in der Inventur erfasst"
      }
    }
  }
}
